import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { CustomActionsCellTypes } from 'src/components/CustomActionsCell/CustomActionsCell.types';
import { EmployeesSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { Employees } from 'src/constants';

import {CustomActionsCell} from '../../components/CustomActionsCell/CustomActionsCell'

import { SortTypes } from './EmployeesScreen.types';


export const rows: GridRowsProp = [
  {
    id: '0125893763',
    name: 'Darlene',
    surName: 'Robertson',
    imageSrc: '',
    email: 'drobertson@monlis.com',
    skillName: 'Cosmetologist',
    rank: 'Junior',
    orders: 148,
    studios: [
      {
        id: '1',
        name: 'Studio 1',
        imageSrc: '',
        streetName: 'Karlstraße 43',
        date: {
          startDate: '14.02.23',
          period: '01 Mar 2023 - 01 Mar 2024',
        },
        regularHours: {
          from: '9:00 AM',
          to: '7:00 PM',
          weekdays: ['MO', 'TU', 'WE', 'TH', 'FRI'],
        },
      },
      {
        id: '2',
        name: 'Studio 2',
        imageSrc: '',
        streetName: 'Karlstraße 43',
        date: {
          startDate: '14.02.23',
          period: '01 Mar 2023 - 01 Mar 2024',
        },
        regularHours: {
          from: '9:00 AM',
          to: '7:00 PM',
          weekdays: ['MO', 'TU', 'WE', 'TH', 'FRI'],
        },
      },
    ],
    services: [
      {
        id: '1',
        name: 'Therapeutic massage',
        imageSrc: '',
        rank: 'Junior',
      },
      {
        id: '2',
        name: 'Salicylic face peeeling',
        imageSrc: '',
        rank: 'Junior',
      },
    ],
  },
] as Array<Employees>;

export const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "ID",
    width: 120,
    sortable: false,
  },
  {
    field: "name",
    headerName: "Name",
    width: 220,
    sortable: false,
    valueGetter: (params) => `${params.row.firstName} ${params.row.lastName}`,
  },
  {
    field: "studio",
    headerName: "Studio",
    width: 210,
    sortable: false,
    valueGetter: (params) => `${params.row.studios.map((studio: any) => studio.title)}`,
  },
  {
    field: "skill",
    headerName: "Skill",
    width: 270,
    sortable: false,
    valueGetter: (params) => `${params.row.skills.map((skill: any) => skill.specialty)}`,
  },
  {
    field: "rank",
    headerName: "Rank",
    minWidth: 170,
    sortable: false,
    valueGetter: (params) => {
      const rankLength = params.row.skills.length;
      if(rankLength === 1) {
        return `${params.row.skills[0].rank}`
      }
      return `${rankLength} ranks`
    },
  },
  {
    field: "services",
    headerName: "Services",
    minWidth: 210,
    flex: 1,
    sortable: false,
    valueGetter: (params) => {
      const servicesLength = params.row.skills.length;
      if(servicesLength === 1) {
        return `${params.row.skills[0].service.title}`
      }
      return `${servicesLength} services`
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    minWidth: 120,
    sortable: false,
    renderCell: (params) => <CustomActionsCell params={params} type={CustomActionsCellTypes.EMPLOYEES} />,
  },
];

export const paramsCatalogue = {
  sortParams: {
    [SortTypes.NAME]: "firstName",
    [SortTypes.SERVICES]: "lastName",
  },
  // uncomment when back is fixed
  searchParams: {
    // [EmployeesSearchTypes.Skill]: "skills",
    // [EmployeesSearchTypes.Name]: "firstName",
    [EmployeesSearchTypes.STUDIO]: "studio",
    [EmployeesSearchTypes.SERVICE]: "service",
    [EmployeesSearchTypes.RANK]: "rank",
  },
};